import React from 'react';
import NewOfficeForm from '../NewOfficeForm';
import Drawer from '~/components/organism/Drawer';
import {
  useInsertOfficeMutation,
  type InsertOfficeMutation,
} from '~/graphql/types';
import withDelayedLoading, {
  type WithDelayedLoading,
} from '~/hocs/withDelayedLoading';
import useTrackEvent from '~/hooks/useTrackEvent';

const text = {
  title: 'Nieuwe vestiging',
};

type Props = {
  accountId: string;

  /** Handler on new Office added */
  onOfficeAdded: () => void;

  /** When the sidebar has to hide */
  hide: () => void;

  /** If the drawer is showing */
  isShowing: boolean;
};

const AddOfficeSidebar: React.FC<WithDelayedLoading & Props> = ({
  accountId,
  setLoading,
  removeLoading,
  hide,
  isShowing,
  onOfficeAdded,
  loading: propsLoading,
}) => {
  const trackEvent = useTrackEvent();
  const onInsertSuccess = (data: InsertOfficeMutation) => {
    /** ----- TRACKING: office_created ----- */
    trackEvent({
      eventName: 'office_created',
      parameters: { office_id: data.insertOffice.id },
    });
    removeLoading();
    onOfficeAdded();
  };

  const onErrorUpdate = () => {
    removeLoading();
  };

  const [insertOffice, { error, loading }] = useInsertOfficeMutation({
    onCompleted: data => onInsertSuccess(data),
    onError: () => onErrorUpdate(),
  });

  return (
    <Drawer active={isShowing} hideSidebar={hide} title={text.title}>
      <NewOfficeForm
        accountId={accountId}
        loading={propsLoading || loading}
        onSubmit={variables => {
          setLoading();
          return insertOffice({
            variables,
          });
        }}
        insertionError={error}
      />
    </Drawer>
  );
};

export default withDelayedLoading<Props>(AddOfficeSidebar);
